import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  ModalDialog,
  ModalDialogBody,
  ModalDialogButtons,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogFooter,
  Typography,
} from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import useSiteData from '../../hooks/useSiteData';
import { LineItemReorderActionStatusContext } from '../contexts/LineItemReorderActionStatusContext';

const ItemDocumentConversionFailureModal = ({ isOpen }) => {
  const { resetReorderActionFeedback } = useContext(
    LineItemReorderActionStatusContext
  );
  const [documentConversionMessages, sharedActionMessages] = useTranslations([
    'documentConversionMessages',
    'sharedActionMessages',
  ]);

  const { externalAppNavigation } = useSiteData();
  const navToCustomerCare = externalAppNavigation.customerCareContact;

  const dismissModal = () => {
    resetReorderActionFeedback();
  };

  const onSubmit = async () => {
    window.location.href = navToCustomerCare;
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onRequestDismiss={dismissModal}
      variant="standard"
    >
      <ModalDialogContent
        style={{ width: '420px', p: '50px' }}
        data-testid="legacy-recreation-modal"
      >
        <ModalDialogCloseButton
          visuallyHiddenLabel={sharedActionMessages.close}
        />
        <ModalDialogBody>
          <Box>
            <Typography
              textColor="standard"
              fontWeight="bold"
              fontSize="large"
              pb={6}
            >
              {documentConversionMessages.noLongerAvailable}
            </Typography>
            <Typography textColor="subtle" pb={6}>
              {documentConversionMessages.createdOnOldSystem}
            </Typography>
            <Typography textColor="subtle" pb={8}>
              {documentConversionMessages.getInTouch}
            </Typography>
          </Box>
        </ModalDialogBody>
        <ModalDialogFooter>
          <ModalDialogButtons>
            <Button
              skin="primary"
              width="full-width"
              onClick={onSubmit}
              style={{ mb: '10px' }}
              data-testid="doc-conversion-failure-visit-help-center"
            >
              {documentConversionMessages.visitOurHelpCenter}
            </Button>
            <Button
              skin="secondary"
              width="full-width"
              onClick={dismissModal}
              data-testid="recreation-modal-skip"
            >
              {documentConversionMessages.goBack}
            </Button>
          </ModalDialogButtons>
        </ModalDialogFooter>
      </ModalDialogContent>
    </ModalDialog>
  );
};

ItemDocumentConversionFailureModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default ItemDocumentConversionFailureModal;
